import utils from '@/utilities'

export default {
  showInternalFunctions (user) {
    return user != null && user.username.endsWith('multimedia-werkstatt.com')
  },
  insertAtCaret (textArea, text) {
    text = text || ''
    if (textArea.selectionStart || textArea.selectionStart === 0) {
      // Others
      let startPos = textArea.selectionStart
      let endPos = textArea.selectionEnd
      textArea.value = textArea.value.substring(0, startPos) + text + textArea.value.substring(endPos, textArea.value.length)
      textArea.selectionStart = startPos + text.length
      textArea.selectionEnd = startPos + text.length
    } else {
      textArea.value += text
    }
  },
  findIconClass (user, auftrag) {
    let iclass = 'float-right '
    switch (auftrag.auftragStatus) {
      case 'Angelegt':
        iclass += 'cc-icon cutterkollegen-exclamation-circle'
        break
      case 'NeueAnfrage':
        if (auftrag.disponentId) {
          iclass += 'cc-icon cutterkollegen-user-check'
        } else {
          iclass += 'cc-icon cutterkollegen-exclamation-circle'
        }
        break
      case 'InBearbeitung':
        if (auftrag.__myAngebot && auftrag.__myAngebot.auftragAngebotStatus === 'Angenommen') {
          iclass += 'cc-icon cutterkollegen-thumbs-up'
          return iclass
        }
        iclass += 'cc-icon cutterkollegen-lightbulb'
        break
      case 'AnfrageAbgelehnt':
        iclass += 'cc-icon cutterkollegen-users-slash'
        break
      case 'Storniert':
        iclass += 'cc-icon cutterkollegen-times-circle'
        break
      case 'Bestaetigt':
        if (user && auftrag.__myAngebot && (auftrag.__myAngebot.auftragAngebotStatus === 'Angenommen') && (user.id === auftrag.cutterId)) {
          iclass += 'cc-icon cutterkollegen-check-circle'
          break
        }
        if (user && auftrag.__myAngebot && (auftrag.__myAngebot.auftragAngebotStatus === 'Angenommen') && (user.id !== auftrag.cutterId)) {
          iclass += 'cc-icon cutterkollegen-users'
          break
        }
        iclass += 'cc-icon cutterkollegen-check-circle'
        break
      // eslint-disable-next-line
      case 'Erledigt':
        iclass += 'cc-icon cutterkollegen-file-invoice'
        break
      case 'Standby':
        iclass += 'cc-icon cutterkollegen-pause-circle'
        break
      case 'Abgeschlossen':
        iclass += 'cc-icon cutterkollegen-flag-checkered'
        break
    }
    return iclass
  },
  // take a single JavaScript File object
  async getFile (file) {
    var reader = new FileReader()
    return new Promise((resolve, reject) => {
      reader.onerror = () => { reader.abort(); reject(new Error('Error parsing file')) }
      reader.onload = function () {
        // This will result in an array that will be recognized by C#.NET WebApi as a byte[]
        let bytes = Array.from(new Uint8Array(this.result))
        // if you want the base64encoded file you would use the below line:
        let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(''))
        // Resolve the promise with your custom file structure
        resolve({
          bytes: bytes,
          base64StringFile: base64StringFile,
          fileName: file.name,
          fileType: file.type
        })
      }
      reader.readAsArrayBuffer(file)
    })
  },
  async uploadFile (callee, api, id) {
    var formData = new FormData()
    const jsonFile = await this.getFile(callee.$refs.fileInput.files[0])
    formData.append('file', jsonFile.base64StringFile)
    formData.append('fileType', jsonFile.fileType)
    formData.append('fileName', jsonFile.fileName)
    let result = await api.action(callee.$refs.actionName.value, id, formData)
    if (result && !result['errorMessage']) {
      utils.makeToast(callee, 'Erfolgreich ausgeführt!', 'success')
    } else {
      utils.makeToast(callee, result['errorMessage'], 'danger')
    }
    callee.refresh()
    return result
  },
  async actionFunc (callee, api, action, id, params) {
    let result
    switch (action.type) {
      case 'FastReply':
        callee.showFastReply = true
        return {'fastReply': true}
      case 'FastReplyDo':
        result = await api.action('FastReply', id, params)
        callee.refresh()
        return result
      case 'Simple':
        result = await api.action(action.name, id, params)
        callee.refresh()
        return result
      case 'Confirm':
        if (confirm(utils.actionConfirm(action))) {
          result = await api.action(action.name, id, params)
          callee.refresh()
          return result
        }
        return {'errorMessage': 'Aktion abgebrochen'}
      case 'Prompt':
        let message = prompt('Nachricht', '')
        if (message) {
          let nParams = params
          if (nParams instanceof FormData) {
            nParams.set('message', message)
          } else {
            nParams.message = message
          }
          result = await api.action(action.name, id, nParams)
          callee.refresh()
          return result
        }
        return {'errorMessage': 'Aktion abgebrochen'}
      case 'FileUpload':
        // jetzt sind wir mal ganz schlau, klick auf den button führt zum filerequest, fileauswahl führt zum upload, upload führt zum statuswechsel
        callee.$refs.actionName.value = action.name
        callee.$refs.fileInput.click()
        return {'noMessage': true}
      case 'FormInput':
      default:
        result = await api.action(action.name, id, params)
        return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/main/vue/functions.js